// client/src/services/authService.js
import axios from '../utils/axiosConfig';

export const login = async (credentials) => {
  try {
    const response = await axios.post('/auth/login', credentials);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to login');
  }
};

export const signup = async (data) => {
  try {
    const response = await axios.post('/auth/signup', data);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to sign up');
  }
};

export const logout = async () => {
  try {
    await axios.post('/auth/logout');
    localStorage.removeItem('isAuthenticated');
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to logout');
  }
};

export const getMe = async () => {
  const response = await axios.get('/auth/me');
  return response.data.user;
};

export const updateMe = (data) => axios.put('/auth/me', data).then(r => r.data.user);
export const submitKyc = (data) => axios.post('/auth/me/kyc', data).then(r => r.data.user);
